import * as Database from './Database';
let _ = require('lodash');

let ConversionRules = {};
Database.doOnValueChange('conversionRules', (key, val) => {
  ConversionRules = val ? val : {};
});

let ServingDictionary = {};
Database.doOnValueChange('servingDictionary', (key, val) => {
  ServingDictionary = val ? val : {};
});
const ONE_MINUTE = 60 * 1000;
export const FOOD_LOGGING_STILL_ACTIVE_TIMER = 30 * ONE_MINUTE;

export const DEFAULT_TIMEZONE = -7;
export const ADMIN_MAP = {
  'CxEbb9eN3nTXRL7A9EIJPyPUlwo1': { name: 'Lucy', isDataEntry: false },
  'ZDwIGInSPFZj7nLHEyZIAZ5VIEJ3': { name: 'Richa', isDataEntry: false },
  'SEudo40FWrUC82ugnfHnqimn7VX2': { name: 'Swapneil', isDataEntry: true },
  '4yKrzPN5RAM0Db0ak95urjuhcr62': { name: 'Vibha', isDataEntry: true },
  'LxYuBQtCdxWdmLG6AZ1xrTZWqH72': { name: 'Maria', isDataEntry: false },
  'lU4bzrPsdIglSWrRVqq11nOjvPB2': { name: "Preiti", isDataEntry: true },
  'k0KFSUDv6eTL1qBCD2pKhcHsPUc2': { name: "Test-1", isDataEntry: false },
  'sjgaTWYc5aXoqsdh8eil6xHkMur2': { name: "Dev-1", isDataEntry: true },
  'eT6XRPmbfvVzb9sZQCFB0OSDKjI2': { name: "Terminal-1", isDataEntry: true }, // satish.pune
  'fgPYPSglO9OcwKu8B2iPkcHrIS22': { name: "Jomel", isDataEntry: true },
  'nJWBz7KbhoZ6mEQlukIqqShSNvE3': { name: "Dani", isDataEntry: true},
  '5UWEEGjBQcSq26YO2lqkqInvN0K2': { name: "Marycris", isDataEntry: true},
  'xcRtqj5JxrTeIWvIamkZzE3j3933': { name: "Don", isDataEntry: true},
  'Msme9GjuK1gUuJ1vKv2FYXl20u42': { name: "Sabel", isDataEntry: true},
  'hvfEp4HliwfTZLn5z0eyhlSAc2j1': { name: "Mark", isDataEntry: true},
  'pDhGnuWr5NhsRrbF7S6HzBAQ4ue2': { name: "Jas", isDataEntry: true},
  'qTw1IFlQCNPVOFwEoWpV8s953zH2': { name: "Elijah", isDataEntry: true},
};


export const NUTRITION_DATA = ['calories', 'protein', 'carbs', 'fat', 'fiber', 'netCarbs', 'sugar'];
export const NUTRITION_DATA_PRIMARY = ['calories', 'protein', 'carbs', 'fat'];

export const NUTRITION_DATA_FRIENDLY_NAME = {
  'calories': 'Calories',
  'protein': 'Protein',
  'carbs': 'Carbs',
  'fat': 'Fat',
  'fiber': 'Fiber',
  'netCarbs': 'Net Carbs',
  'sugar': 'Sugar'
}

export const NUTRITION_DATA_SHOW_MAP = {
  'calories': 'showCalories',
  'protein': 'showProtein',
  'carbs': 'showCarbs',
  'fat': 'showFat',
  'fiber': 'showFiber',
  'netCarbs': 'showNetCarbs',
  'sugar': 'showSugar'
}

export const NUTRITION_DATA_DEFAULT_STAYUNDER = {
  'calories': true,
  'protein': false,
  'carbs': true,
  'fat': true,
  'fiber': false,
  'netCarbs': true,
  'sugar': true
}

export const FOOD_TAGS = { // FUTURE: These should really be constant IDs, not strings since names can change!
  BeansLegumes: 'Beans & Legumes',
  BeverageCaloric: 'Beverage - Caloric',
  BeverageCaloricAlcohol: 'Beverage - Caloric - Alcohol',
  BeverageCaloricCaffeine: 'Beverage - Caloric - Caffeine',
  BeverageNonCaloric: 'Beverage - Non-caloric',
  DairyEgg: 'Dairy & Eggs',
  Fruits: 'Fruits',
  GrainsCereal: 'Grains & Cereal',
  Meat: 'Meat',
  NutsSeeds: 'Nuts & Seeds',
  OilsFats: 'Oils & Fats',
  ProcessedSavory: 'Processed Savory (e.g., chips)',
  ProcessedSweets: 'Processed Sweets',
  Sauces: 'Sauces',
  Soups: 'Soups',
  Spices: 'Spices & Herbs',
  VegetablesNonStarchy: 'Vegetables - Non-starchy',
  VegetablesStarchy: 'Vegetables - Starchy'
};

export const FOOD_GROUP_HABITS = ['water'];

export const FOOD_GROUP_HABITS_TO_TAGS_MAP = {
  'water': [
    FOOD_TAGS.BeverageCaloric,
    FOOD_TAGS.BeverageCaloricCaffeine,
    FOOD_TAGS.BeverageNonCaloric
  ]
};

export const TIMERANGE = {
  TimeRange1: "6 AM - 12 PM",
  TimeRange2: "12 PM - 4 PM",
  TimeRange3: "4 PM - 7 PM",
  TimeRange4: "7 PM - 9 PM",
  TimeRange5: "9 PM - 12 AM",
  TimeRangeOther: 'Other'
};

// NOTE: May also need to update DATA_ENTRY_TAGS in datatool/ChatSearch.js
export const CHAT_EFFORT = {
  UNIQUE: 'unique',
  EDIT_FAQ: 'edited-faq',
  VERBATIM_FAQ: 'verbatim-faq',
  DATA_ENTRY: 'data-entry'
};

export const PROTEIN_HABIT_ID = 'chf!53d10c95-433e-465e-d28b-7a5bd3446544';

const RANKED_FOOD_TAGS = {};
RANKED_FOOD_TAGS[FOOD_TAGS.BeverageCaloric] = 0;
RANKED_FOOD_TAGS[FOOD_TAGS.BeverageCaloricAlcohol] = 0;
RANKED_FOOD_TAGS[FOOD_TAGS.BeverageCaloricCaffeine] = 0;
RANKED_FOOD_TAGS[FOOD_TAGS.BeverageNonCaloric] = 0;
RANKED_FOOD_TAGS[FOOD_TAGS.Meat] = 1;
RANKED_FOOD_TAGS[FOOD_TAGS.GrainsCereal] = 2;
RANKED_FOOD_TAGS[FOOD_TAGS.VegetablesNonStarchy] = 3;
RANKED_FOOD_TAGS[FOOD_TAGS.VegetablesStarchy] = 3;
RANKED_FOOD_TAGS[FOOD_TAGS.BeansLegumes] = 4;
RANKED_FOOD_TAGS[FOOD_TAGS.ProcessedSweets] = 5;
RANKED_FOOD_TAGS[FOOD_TAGS.DairyEgg] = 6;
RANKED_FOOD_TAGS[FOOD_TAGS.NutsSeeds] = 7;
RANKED_FOOD_TAGS[FOOD_TAGS.Fruits] = 8;
RANKED_FOOD_TAGS[FOOD_TAGS.Soups] = 9;
RANKED_FOOD_TAGS[FOOD_TAGS.ProcessedSavory] = 10;
RANKED_FOOD_TAGS[FOOD_TAGS.Sauces] = 11;
RANKED_FOOD_TAGS[FOOD_TAGS.Spices] = 11;
RANKED_FOOD_TAGS[FOOD_TAGS.OilsFats] = 11;

const UNIT_AMOUNT = { liter: {}, gram: {} };
// TODO: When every tag gets its own default rules, then switch to reading from /conversionRules instead of hard-coding here
// This is contingent on Asana #615054078338777 getting done.
UNIT_AMOUNT[FOOD_TAGS.BeverageCaloric] = { conversions: { liter: 0.236588, gram: 226.796, calories: 100 } }; // 1 cup, 8 oz
UNIT_AMOUNT[FOOD_TAGS.BeverageCaloricAlcohol] = { conversions: { liter: 0.236588, gram: 226.796, calories: 100 } }; // 1 cup, 8 oz
UNIT_AMOUNT[FOOD_TAGS.BeverageCaloricCaffeine] = { conversions: { liter: 0.236588, gram: 226.796, calories: 100 } }; // 1 cup, 8 oz
UNIT_AMOUNT[FOOD_TAGS.BeverageNonCaloric] = { conversions: { liter: 0.236588, gram: 226.796, calories: 0 } }; // 1 cup, 8 oz
UNIT_AMOUNT[FOOD_TAGS.Meat] = { conversions: { liter: 0.1774412, gram: 106.3107, calories: 200 } }; // .75 cup, 3.75 oz
UNIT_AMOUNT[FOOD_TAGS.DairyEgg] = { conversions: { liter: 0.236588, gram: 226.796, calories: 120 } }; // 1 cup, 8 oz
UNIT_AMOUNT[FOOD_TAGS.NutsSeeds] = { conversions: { liter: 0.05914706, gram: 28.3495, calories: 170 } }; // .25 cup, 1 oz
UNIT_AMOUNT[FOOD_TAGS.BeansLegumes] = { conversions: { liter: 0.1774412, gram: 170.097, calories: 150 } }; // .75 cup, 6 oz
UNIT_AMOUNT[FOOD_TAGS.Sauces] = { conversions: { liter: 0.0295735, gram: 56.699, calories: 50 } }; // 2 tbsp, 2 oz
UNIT_AMOUNT[FOOD_TAGS.Spices] = { conversions: { liter: 0.00492892, gram: 2.5, calories: 10 } }; // 1 tsp, 2.5 g
// These below are not yet stored in firebase
UNIT_AMOUNT[FOOD_TAGS.GrainsCereal] = { conversions: { liter: 0.1774412, gram: 85.0486, calories: 150 } }; // .75 cup, 3 oz
UNIT_AMOUNT[FOOD_TAGS.Fruits] = { conversions: { liter: 0.1774412, gram: 85.0486, calories: 80 } }; // .75 cup, 3 oz
UNIT_AMOUNT[FOOD_TAGS.VegetablesNonStarchy] = { conversions: { liter: 0.236588, gram: 170.097, calories: 30 } }; // 1 cup, 6 oz
UNIT_AMOUNT[FOOD_TAGS.VegetablesStarchy] = { conversions: { liter: 0.1774412, gram: 141.748, calories: 100 } }; // .75 cup, 5 oz
UNIT_AMOUNT[FOOD_TAGS.ProcessedSavory] = { conversions: { liter: 0.1774412, gram: 42.5243, calories: 150 } }; // .75 cup, 1.5 oz
UNIT_AMOUNT[FOOD_TAGS.ProcessedSweets] = { conversions: { liter: 0.1774412, gram: 141.748, calories: 150 } }; // .75 cup, 5 oz
UNIT_AMOUNT[FOOD_TAGS.Soups] = { conversions: { liter: 0.354882, gram: 340.194, calories: 120 } }; // 1.5 cup, 12 oz
UNIT_AMOUNT[FOOD_TAGS.OilsFats] = { conversions: { liter: 0.0295735, gram: 28.3495, calories: 100 } }; // 1 tbsp, 1 oz

export function toStartCaseIgnoringSymbols(value) {
  // Normalizes spacing between words. Capitalizes each word. Ignores symboles and numbers.
  let valueSplit = value.split(/\s+/);
  let returnValueSplit = [];
  for (let i = 0; i < valueSplit.length; i++) {
    let word = valueSplit[i];
    returnValueSplit.push(_.capitalize(word));
  }
  return returnValueSplit.join(' ');
}

// IMPORTANT: This should match the same getGoalForDateString in VivaDashboard project
// FUTURE: Put this in a shared lib instead of dupe code.
export function getGoalForDateString(goalHistories /* descending date order */, targetDate, defaultStayUnder) {
  if (!goalHistories) {
    return { type: 'number', value: -1, stayUnder: defaultStayUnder };
  }

  let goalChangeDates = Object.keys(goalHistories);
  for (let i = goalChangeDates.length - 1; i >= 0; i--) {
    let goalChangeDate = goalChangeDates[i];
    if (goalChangeDate <= targetDate) { // strings in the form "yyyy-mm-dd"
      let goal = goalHistories[goalChangeDate]
      let stayUnder = goalHistories.stayUnder ?
        (goalHistories.stayUnder[goalChangeDate] != undefined ? goalHistories.stayUnder[goalChangeDate] : defaultStayUnder) :
        defaultStayUnder;
      if (_.isFinite(goal)) {
        return { type: 'number', value: _.toNumber(goal), stayUnder: stayUnder };
      } else if (_.isArrayLike(goal)) {
        return { type: 'array', value: goal, stayUnder: stayUnder };
      } else {
        console.error('Unown goal type')
      }
    }
  }
  return { type: 'number', value: -1, stayUnder: defaultStayUnder };
}

// IMPORTANT: Should match same function name in VivaDashboard project.
export function getAdminTZDateFromDateString(dateString) {
  let dateSplit = dateString.split("-");
  let date = new Date(parseInt(dateSplit[0]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[2]));
  return date;
}

export function getPrevDateString(dateString) {
  let dateSplit = dateString.split("-");
  let dateObject = new Date(parseInt(dateSplit[0]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[2]));
  dateObject.setDate(dateObject.getDate() - 1);
  return getUTCDateString(dateObject);
}

// IMPORTANT: This should match the same function in VivaDashboard project
// FUTURE: Put this in a shared lib instead of dupe code.
export function getDailyGoalNumFromWeeklyGoalsObj(weeklyGoal, dateString) {
  let dailyGoal;
  if (weeklyGoal.type === 'array') {
    let dayOfWeek = getAdminTZDateFromDateString(dateString).getDay();
    dailyGoal = _.toNumber(weeklyGoal.value[dayOfWeek]);
  } else {
    dailyGoal = _.toNumber(weeklyGoal.value) / 7;
  }
  return dailyGoal;
}

// IMPORTANT: This should match the same function in VivaDashboard project
// FUTURE: Put this in a shared lib instead of dupe code.
export function getWeeklyGoalNumFromWeeklyGoalsObj(weeklyGoal) {
  if (weeklyGoal.type === 'array') {
    let goalsByDay = weeklyGoal.value; // Array of 7 goals, one for each day.
    let weeklyGoalNum = 0;
    goalsByDay.forEach(goalNum => {
      weeklyGoalNum += _.toNumber(goalNum);
    });
    return weeklyGoalNum
  } else {
    return _.toNumber(weeklyGoal.value);
  }
}

export function getFoodDataForDate(targetDate, totalDailyFoodData) {
  let foodData = { totalsForTheDay: {} };
  NUTRITION_DATA.forEach(dataName => {
    return foodData.totalsForTheDay[dataName] = 0;
  });

  if (!totalDailyFoodData) {
    return foodData;
  }

  for (let i = 0; i < totalDailyFoodData.length; i++) {
    let currFoodData = totalDailyFoodData[i];
    if (currFoodData.date === targetDate) {
      foodData = currFoodData;
    }
  }
  return foodData;
}

export function convertAndRoundNutritionData(dataName, val) // Make sure this is in sync with same method in viva-dash
{
  if (dataName === 'calories') {
    return _.round(_.toNumber(val));
  } else {
    return _.round(_.toNumber(val), 1);
  }
}

export function makeAPICall(apiPath, json, callback, callbackOnError) {
  console.log(`makeAPICall: calling ${process.env.REACT_APP_API_URL + apiPath}`);

  // The 'test' env uses an http endpoint, so use as workaround this
  // CORS solution from: https://stackoverflow.com/questions/43262121/trying-to-use-fetch-and-pass-in-mode-no-cors
  let endpoint = process.env.REACT_APP_ENV === 'test' ?
    'https://viva-cors-proxy.herokuapp.com/' + process.env.REACT_APP_API_URL + apiPath :
    process.env.REACT_APP_API_URL + apiPath;
  console.log(`makeAPICall: calling ${endpoint}`);

  fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(json),
    headers: { "Content-Type": "application/json" }
  }).then(res => {
    if (!res.ok) {
      return { error: res.statusText }
    }
    else {
      return res.json();
    }
  }).then(body => {
    if (callback) {
      callback(body);
    }
  }).catch(err => {
    console.error(`makeAPICall: path ${apiPath} error: ${err.message}`);
    if (callbackOnError) {
      callbackOnError(err);
    }
  });
}

export async function makeAPICallAsync(apiPath, json, method) {
  // The 'test' env uses an http endpoint, so use as workaround this
  // CORS solution from: https://stackoverflow.com/questions/43262121/trying-to-use-fetch-and-pass-in-mode-no-cors
  console.log(`REACT_APP_ENV: ${process.env.REACT_APP_ENV}`);
  let endpoint = process.env.REACT_APP_ENV === 'test' ?
    'https://viva-cors-proxy.herokuapp.com/' + process.env.REACT_APP_API_URL + apiPath :
    process.env.REACT_APP_API_URL + apiPath;

  try {
    const requestInfo = method === 'GET' ?
      {
        method: method,
        headers: { "Content-Type": "application/json" }
      } :
      {
        method: method ? method : 'POST',
        body: JSON.stringify(json),
        headers: { "Content-Type": "application/json" }
      };
    let res = await fetch(endpoint, requestInfo);

    let retVal = res.ok ? await res.json() : { error: res.statusText };
    return retVal;
  } catch (err) {
    console.error(`makeAPICall: path ${apiPath} error: ${err.message}`);
    return { error: err.message };
  }
}

export async function getUserWeeklyStartDayAsync(userId) {
  let weeklyStartDay = await Database.getFirebaseEntryAsync(`users/${userId}/weeklyStartDay`);
  return _.toNumber(weeklyStartDay, 1);
}

export function getLocalDateString(d, timezoneOffset) {
  if (timezoneOffset == null || timezoneOffset == undefined) {
    timezoneOffset = DEFAULT_TIMEZONE;
  }

  d = new Date((d).getTime() + (timezoneOffset * 60 * 60 * 1000));
  return getUTCDateString(d);
}

export function getNumHoursPassedInLocalTime(timezoneOffset) {
  if (timezoneOffset == null || timezoneOffset == undefined) {
    timezoneOffset = DEFAULT_TIMEZONE;
  }

  var d = new Date();
  d = new Date(d.getTime() + (timezoneOffset * 60 * 60 * 1000));
  return d.getUTCHours();
}

export function getUTCDateString(d) { // This should only be called for any already-offsetted dates
  let year = d.getUTCFullYear();
  let date = ("0" + d.getUTCDate()).slice(-2); // Append 0 to 1-digit numbers to force 2-digits
  let month = ("0" + (d.getUTCMonth() + 1)).slice(-2); // month is 0 base indexed
  return year + "-" + month + "-" + date;
}

export function getLocalTimeString(timestamp, timezoneOffset) {
  let d = new Date(timestamp + (timezoneOffset * 60 * 60 * 1000));
  return getUTCTimeString(d);
}

export function getUTCTimeString(d) { // This should only be called for any already-offsetted dates
  let hour = ("0" + d.getUTCHours()).slice(-2); // Append 0 to 1-digit numbers to force 2-digits
  let minute = ("0" + d.getUTCMinutes()).slice(-2); // Append 0 to 1-digit numbers to force 2-digits
  return hour + ":" + minute;
}

export function getVerbatimDateString(d) {
  let year = d.getFullYear();
  let date = ("0" + d.getDate()).slice(-2); // Append 0 to 1-digit numbers to force 2-digits
  let month = ("0" + (d.getMonth() + 1)).slice(-2); // month is 0 base indexed
  return year + "-" + month + "-" + date;
}

export function addDaysToDateString(startingDateString, daysToAdd) {
  let finalDateString = new Date(startingDateString);
  finalDateString.setDate(finalDateString.getDate() + daysToAdd);
  return getUTCDateString(finalDateString);
}

export function getPercentOf(percent, totalVal) {
  if (!percent || !totalVal) {
    return 0;
  }

  let value = _.toNumber(percent) / 100 * _.toNumber(totalVal);
  if (isNaN(value)) {
    return 0;
  }
  return _.round(value, 2);
}

export function itemsAreEqualByKey(item1, item2, key) {
  if ((item1 && !item2) || (!item1 && item2)) {
    return false;
  } else if (!item1 && !item2) {
    return true; // Count all null, undef, empty, etc as equal.
  } {
    return item1[key] === item2[key];
  }
}

export function dataEntryContentAreEqual(d1, d2) {
  if (d1 && !d2) {
    return false;
  }

  if (d2 && !d1) {
    return false;
  }

  if (!d1 && !d2) {
    return true;
  }

  return itemsAreEqualByKey(d1, d2, 'key') &&
    d1.logId === d2.logId &&
    d1.queryTimestamp === d2.queryTimestamp &&
    d1.originalText === d2.originalText &&
    d1.topHitId === d2.topHitId;
}

export function createGuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export function getFoodQualityMatches(tags, usersCannedFoodHabitsTagsIndex, usersCannedHabits) {
  let returnHabits = [];
  if (tags) {
    tags.forEach(tag => {
      let habitIds = usersCannedFoodHabitsTagsIndex[tag];
      returnHabits = _.union(returnHabits, habitIds); // tag <-> habitId is a many <-> many relationship
    });
  }

  if (_.includes(usersCannedHabits, PROTEIN_HABIT_ID) && !_.includes(returnHabits, PROTEIN_HABIT_ID)) {
    returnHabits.push(PROTEIN_HABIT_ID); // Protein is special. Doesn't depend just on tags, but macros as well.
  }
  return returnHabits;
}

export function isFoodQualityHabit(habitId) {
  return habitId ? habitId.startsWith('chf!') : false;
}

export function isWaterHabit(habitId) {
  return habitId === 'chf!d45b697d-3928-0d7d-eca6-2ba24defcbd2';
}

function isProteinHabit(habitId) {
  return habitId === PROTEIN_HABIT_ID;
}

export function getAdjustedNumUnitServings(habitId, food, currentWeight) {
  if (isProteinHabit(habitId)) {
    let protein = food.protein ? food.protein : 0;
    return _.toNumber(protein) / getOneServingProtein(currentWeight);
  } else {
    return food.numberOfUnitServings === undefined ? 1 : _.toNumber(food.numberOfUnitServings);
  }
}

function getOneServingProtein(currentWeight) {
  return currentWeight ? (_.toNumber(currentWeight) * .12) : 15;
}

export function isTrue(val, defaultVal) {
  if (val === undefined || val === null || val === '') {
    return defaultVal;
  }

  return val === true || val === 'true';
}

function splitByCommonSeparators(text, excludeSpace, includeConjunction) {
  let trimTerms = ' ()[]{},;!:';
  if (text === '') {
    text = _.trim(text, trimTerms);
    return _.trimEnd(text, '.'); // Only trim periods from the end since they can be decimals
  } else if (!text) {
    return text;
  }

  text = _.trim(text, trimTerms);
  text = _.trimEnd(text, '.'); // Only trim periods from the end since they can be decimals

  // Periods and slashs since they can be decimals or fractions. Only accept periods that are followed by a space.
  let splitTerms = excludeSpace ?
    (includeConjunction ? / w\/| with | and | plus | - |! |\. |[\n,;():\+&]+/ : /! |\. | - |[\n,;():]+/) :
    (includeConjunction ? / w\/| with | and | plus | - |! |\. |[\n\s,;():\+&]+/ : /! |\. | - |[\n\s,;():]+/);

  let textSplit = text.split(splitTerms);
  for (let i = 0; i < textSplit.length; i++) {
    textSplit[i] = _.trim(textSplit[i], trimTerms);
    textSplit[i] = _.trimEnd(textSplit[i], '.'); // Only trim periods from the end since they can be decimals
  }
  return textSplit;
}

export function getNumberOfUnitServings(servingNumber, servingUnitNumber, servingUnitName, tags) {
  let numUnitsOfServing = servingNumber * servingUnitNumber;
  if (!servingUnitName) {
    return numUnitsOfServing;
  }

  let returnVal = -1;
  let servingNameParts = splitByCommonSeparators(servingUnitName, false);
  for (let s = 0; s < servingNameParts.length; s++) {
    let servingName = servingNameParts[s];
    let servingRootName = ServingDictionary[servingName.toLowerCase()];
    if (!servingRootName) {
      servingRootName = '';
    }

    returnVal = -1;
    let conversionRules = ConversionRules[servingRootName];
    if (!conversionRules) {
      continue;
    }

    let rankedTags = _.sortBy(tags, tag => RANKED_FOOD_TAGS[tag]);
    if (tags) {
      for (let i = 0; i < rankedTags.length; i++) {
        let tag = rankedTags[i];

        if (UNIT_AMOUNT[tag]) {
          let unitAmtInLiters = UNIT_AMOUNT[tag]['conversions']['liter'];
          let unitAmtInGrams = UNIT_AMOUNT[tag]['conversions']['gram'];

          let conversionRuleForThisTag = _.get(conversionRules, `filters.tags.${tag}`);
          if (conversionRuleForThisTag) {
            returnVal = getNOUFromConversionRule(conversionRuleForThisTag, unitAmtInLiters, unitAmtInGrams, numUnitsOfServing);
          } else {
            returnVal = getNOUFromConversionRule(conversionRules, unitAmtInLiters, unitAmtInGrams, numUnitsOfServing);
          }
        }

        if (returnVal >= 0) { // Just return the first valid match. < 0 means it couldn't find any
          return returnVal;
        }
      }
    }
  }
  return returnVal < 0 ? numUnitsOfServing : returnVal; // If < 0, that means nothing got computed based on serving name. Assume the serving name is just "1 serving."
}


function getNOUFromConversionRule(conversionRule, unitAmtInLiters, unitAmtInGrams, numUnitsOfServing) {
  let conversionForLiter = _.get(conversionRule, 'conversions.liter');
  let retVal = -1;
  if (conversionForLiter) {
    retVal = _.round(numUnitsOfServing * conversionForLiter / unitAmtInLiters, 2);
  } else {
    let conversionForGram = _.get(conversionRule, 'conversions.gram');
    if (conversionForGram) {
      retVal = _.round(numUnitsOfServing * conversionForGram / unitAmtInGrams, 2);
    }
  }

  return retVal;
}

export const CRUISING_OBJ_PATH = 'Cruising.value'; // For lodash retrieval
export function getLastDateStringWithinWindow(startingDateString, sortedDateStringsList, bodyStatHistories, lookBackDays) {
  let lookBackDateStringIdeal = addDaysToDateString(startingDateString, -lookBackDays);
  let currDateString = null;
  for (let i = sortedDateStringsList.length - 1; i >= 0; i--) {
    if (sortedDateStringsList[i] <= lookBackDateStringIdeal) {
      break;
    }

    if (!_.get(bodyStatHistories[sortedDateStringsList[i]], CRUISING_OBJ_PATH)) {
      currDateString = sortedDateStringsList[i]; // Skip these since user doesn't really care about goal during Cruising weeks
    }
  }

  return currDateString;
}

// Performs in-place update of food histories on entryItem.
export function updateFoodEntryHistories(entryItem, consolidatedServingName, foodName, newFoodFormEntry /* optional */, adminId) {
  let newRevisionHistory;
  if (!_.isEmpty(newFoodFormEntry) && newFoodFormEntry != {}) {
    newRevisionHistory = buildRevisionHistory(newFoodFormEntry, foodName, consolidatedServingName, adminId);
  } else {
    newRevisionHistory = buildRevisionHistory(entryItem, foodName, consolidatedServingName, adminId);
  }

  if (_.isEmpty(entryItem.revisionHistory)) {
    entryItem.revisionHistory = [newRevisionHistory];
  } else {
    entryItem.revisionHistory.push(newRevisionHistory);
  }

  if (_.isEmpty(entryItem.loggedTimestamps)) {
    entryItem.loggedTimestamps = [];
  }
  entryItem.loggedTimestamps.push({
    timestamp: Date.now(),
    source: 'manual'
  });
}

export function buildRevisionHistory(foodEntry, consolidatedServingName, foodName, adminId) {
  let nutritionDataReport = '';
  for (let dataName of NUTRITION_DATA) {
    nutritionDataReport += `| ${dataName}: ${foodEntry[dataName]}`;
  }

  return `You logged: ${consolidatedServingName} ${foodName} ${nutritionDataReport} by ${ADMIN_MAP[adminId].name} <did>${adminId}</did>`;
}

export function fromExternalSource(hitId) {
  if (!hitId) {
    return false;
  }
  return hitId.startsWith('FS_')
}

export function mapDataEntryToFirebaseFoodEntry(dataEntry, logId) {
  let returnObj = {
    foodId: dataEntry.topHitId,
    name: dataEntry.topHitName,
    brandName: dataEntry.brandName,
    calories: dataEntry.calories,
    carbs: dataEntry.carbs,
    fat: dataEntry.fat,
    protein: dataEntry.protein,
    fiber: dataEntry.fiber,
    netCarbs: dataEntry.netCarbs,
    sugar: dataEntry.sugar,
    serving: dataEntry.topServingName,
    servingNumber: dataEntry.topServingNumber,
    consolidatedServingName: dataEntry.consolidatedServingName,
    foodGroups: dataEntry.foodGroups,
    targetDate: dataEntry.targetDate,
    loggedTimestamps: dataEntry.loggedTimestamps,
    revisionHistory: dataEntry.revisionHistory,
    images: _.isEmpty(dataEntry.images) ? [] : dataEntry.images,
    notes: _.isEmpty(dataEntry.notes) ? null : dataEntry.notes,
    urls: _.isEmpty(dataEntry.urls) ? [] : dataEntry.urls,
    ingredients: _.isEmpty(dataEntry.ingredients) ? [] : dataEntry.ingredients,
    detailNotepad: _.isEmpty(dataEntry.detailNotepad) ? {} : dataEntry.detailNotepad,
    category: _.isEmpty(dataEntry.category) ? null : dataEntry.category,
    totalServings: dataEntry.totalServings ? dataEntry.totalServings : null, // If totalServings is 0, then null it completely.
  };

  returnObj.detailNotepad = _stripDetailNotepadOfNutrientNotes(returnObj.detailNotepad);
  returnObj.ingredients = _populateIngredientNotesForLogId(logId, returnObj.ingredients);

  // Add this if it's from our user food history index. This is so that
  // it makes it easier for server to retrieve this item. (they will try
  // by id first and then by key, the latter may not always succeed)
  if (dataEntry.topHitId && !fromExternalSource(dataEntry.topHitId)) {
    returnObj['foodHistoryId'] = dataEntry.topHitId;
  }

  return returnObj;
}

// Merges a new food form entry with an existing firebase food log entry doc and returns the result.
// Used for correcting foods after they've been logged at least once already.
export function mergeFoodFormEntryWithFirebaseEntry(existingFoodEntry, newFoodFormEntry, logId) {
  const returnObj = {
    foodId: newFoodFormEntry.foodId,
    name: newFoodFormEntry.name,
    brandName: newFoodFormEntry.brandName,
    calories: newFoodFormEntry.calories,
    carbs: newFoodFormEntry.carbs,
    fat: newFoodFormEntry.fat,
    protein: newFoodFormEntry.protein,
    fiber: newFoodFormEntry.fiber,
    netCarbs: newFoodFormEntry.netCarbs,
    sugar: newFoodFormEntry.sugar,
    serving: newFoodFormEntry.serving,
    servingNumber: newFoodFormEntry.servingNumber,
    consolidatedServingName: newFoodFormEntry.consolidatedServingName,
    foodGroups: newFoodFormEntry.foodGroups,
    targetDate: newFoodFormEntry.targetDate,
    loggedTimestamps: existingFoodEntry.loggedTimestamps,
    revisionHistory: existingFoodEntry.revisionHistory,
    images: _.isEmpty(existingFoodEntry.images) ? [] : existingFoodEntry.images,
    notes: _.isEmpty(existingFoodEntry.notes) ? null : existingFoodEntry.notes,
    urls: _.isEmpty(existingFoodEntry.urls) ? [] : existingFoodEntry.urls,
    detailNotepad: _.isEmpty(existingFoodEntry.detailNotepad) ? {} : existingFoodEntry.detailNotepad,
    // For ingredients and category, use whatever is in the food form entry, because it's possible user logged "same recipe as yesterday".
    ingredients: _.isEmpty(newFoodFormEntry.ingredients) ? [] : newFoodFormEntry.ingredients,
    category: _.isEmpty(newFoodFormEntry.category) ? 'unspecified' : newFoodFormEntry.category,
    totalServings: newFoodFormEntry.totalServings ? newFoodFormEntry.totalServings : null, // If totalServings is 0, then null it completely.
  };

  returnObj.detailNotepad = _stripDetailNotepadOfNutrientNotes(returnObj.detailNotepad);
  returnObj.ingredients = _populateIngredientNotesForLogId(logId, returnObj.ingredients);

  // Add this if it's from our user food history index. This is so that
  // it makes it easier for server to retrieve this item. (they will try
  // by id first and then by key, the latter may not always succeed)
  if (returnObj.foodId && !fromExternalSource(returnObj.foodId)) {
    returnObj['foodHistoryId'] = returnObj.foodId;
  }

  return returnObj;
}

function _stripDetailNotepadOfNutrientNotes(detailNotepad) {
  if (!_.isEmpty(detailNotepad)) {
    delete detailNotepad.calories;
    delete detailNotepad.carbs;
    delete detailNotepad.protein;
    delete detailNotepad.fat;
  }
  return detailNotepad;
}

function _populateIngredientNotesForLogId(logId, ingredients) {
  if (!logId) {
    return ingredients;
  }

  // ingredient.notes is the notes that will be shown to the user for this firestore ingredient instance - it doesn't keep history and is not indexed.
  // Wherease ingredient.logNote is the last notes the users added for this particular logId - it keeps history and gets indexed.
  for (const ingredient of ingredients) {
    if (ingredient.logNote) {
      for (let logNote of ingredient.logNote) {
        if (logNote.logId === logId) {
          ingredient.notes = logNote.note;
          break;
        }
      }
    }
  }
  return ingredients;
}

// Invoked after DEP confirms a food for this data entry todo form.
export function mapFoodFormEntryToPartialDataEntry(foodFormEntry) {
  const partialDataEntry = {
    manualPick: true,
    topHitId: foodFormEntry.foodId,
    topHitName: foodFormEntry.name,
    brandName: foodFormEntry.brandName,
    calories: foodFormEntry.calories,
    carbs: foodFormEntry.carbs,
    fat: foodFormEntry.fat,
    protein: foodFormEntry.protein,
    fiber: foodFormEntry.fiber,
    netCarbs: foodFormEntry.netCarbs,
    sugar: foodFormEntry.sugar,
    topServingName: foodFormEntry.serving,
    topServingNumber: foodFormEntry.servingNumber,
    foodGroups: foodFormEntry.foodGroups,
    targetDate: foodFormEntry.targetDate,
    consolidatedServingName: foodFormEntry.consolidatedServingName,
    // Overwrite ingredients and category with foood form entry, because it's possible user just logged "same recipe as yesterday".
    ingredients: _.isEmpty(foodFormEntry.ingredients) ? [] : foodFormEntry.ingredients,
    category: _.isEmpty(foodFormEntry.category) ? null : foodFormEntry.category,
    totalServings: foodFormEntry.totalServings ? foodFormEntry.totalServings : null, // If totalServings is 0, then null it completely.
    // Why skip urls and detailNotepad? Because these fields shouldn't be overwritten by the foodFormEntry.
    // Whatever's already in the DataEntry object in firestore gets to stay there.
  };
  return partialDataEntry;
}

// Invoked after DEP confirms an ingredient for a recipe builder ingredient form.
export function mergeFoodFormEntryWithIngredientFbEntry(existingIngredientEntry, newFoodFormEntry) {
  // Ignore existingFirebaseEntry except for revisionHistory and notes, if any.
  if (existingIngredientEntry.revisionHistory && existingIngredientEntry.revisionHistory.length > 0) {
    newFoodFormEntry.revisionHistory = existingIngredientEntry.revisionHistory;
  }

  if (existingIngredientEntry.notes) {
    newFoodFormEntry.notes = existingIngredientEntry.notes;
  }

  return newFoodFormEntry;
}

// If revisionHistory only has source: "user" loggedTimstamps but revisionHistory contains a "You logged:"
// then that means this TODO was copied over from a previous log and then the user made a correction to it.
// This function is used for timestamp analytics.
export function isCopiedThenCorrectedFood(loggedTimestamps, revisionHistory) {
  let allSourcesAreUser = true;
  for (const timestamp of loggedTimestamps) {
    if (timestamp.source !== 'user') {
      allSourcesAreUser = false;
    }
  }

  if (allSourcesAreUser) {
    let historyContainsYouLogged = false;
    for (const history of revisionHistory) {
      if (history.includes('You logged:')) {
        historyContainsYouLogged = true;
        break;
      }
    }
    return allSourcesAreUser && historyContainsYouLogged;
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/Util.js